import { css } from "styled-components"
import { Theme } from "styles/theme"

const Heading = css`
  color: ${(props: { theme: Theme }) => props.theme.palette.text.main};
  font-family: ${(props: { theme: Theme }) => props.theme.font.family};
  font-weight: 700;
  margin: 0;
`

export default Heading
